import { render, staticRenderFns } from "./activity-card.vue?vue&type=template&id=20292501&scoped=true&"
import script from "./activity-card.vue?vue&type=script&lang=js&"
export * from "./activity-card.vue?vue&type=script&lang=js&"
import style0 from "./activity-card.vue?vue&type=style&index=0&id=20292501&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20292501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20292501')) {
      api.createRecord('20292501', component.options)
    } else {
      api.reload('20292501', component.options)
    }
    module.hot.accept("./activity-card.vue?vue&type=template&id=20292501&scoped=true&", function () {
      api.rerender('20292501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/activity-card.vue"
export default component.exports